module.exports = __webpack_public_path__ + "res/guess.f0e5e9252b1079cb6b084210a82017a1.webp";